import React from "react";

import Form from "@Components/Form";
import {
  APP_FEATURE_CONTROL_URL,
  STORAGE_CONSTANT,
  URLS,
} from "configs/constants";
import { getAssignedModule } from "utils";
import * as Yup from "yup";

const initialValues = {
  active: false,
  feature: "",
  message: "",
};

const AppFeatureControlForm = () => {
  const validationSchema = Yup.object({
    message: Yup.string().when("active", {
      is: false,
      then: Yup.string().required("Message is required"),
    }),
  });
  const formFields = [
    {
      type: "renderonly",
      key: "feature",
      name: "feature",
      label: "Feature",
      size: "medium",
      gridSize: { xs: 12, sm: 4, md: 4, lg: 4 },
      disabled: true,
    },
    {
      type: "input",
      name: "message",
      label: "Message (Upto 30 characters only)",
      fullWidth: true,
      gridSize: { xs: 12 },
      requiredValidation: "active",
      renderKey: "active",
      renderValue: false,
    },
  ];

  const formButtons = ["save", "cancel"];

  let module = getAssignedModule(location.pathname);
  let actionPermission = false;
  if (!module || module === "") {
    actionPermission = true;
  } else {
    let updatedModules = JSON.parse(
      localStorage.getItem(STORAGE_CONSTANT.NEW_MODULES)
    );
    if (updatedModules[module]) {
      let modulePermissions = updatedModules[module].map((perm) => {
        if (typeof perm === "string") {
          return perm.toLowerCase();
        }
        return perm;
      });
      if (modulePermissions.includes("change status")) {
        actionPermission = true;
      }
    }
  }
  if (actionPermission) {
    formFields.push({
      type: "switch",
      name: "active",
      label: "Is Active?",
      required: true,
      nolabel: "No",
      yeslabel: "Yes",
      gridSize: { xs: 12 },
    });
  }

  return (
    <Form
      initialValues={initialValues}
      submitUrl={APP_FEATURE_CONTROL_URL}
      listRoute={URLS.FEATURE_CONTROL_MODULE}
      formFields={formFields}
      formButtons={formButtons}
      formTitle="App Feature Control"
      validationSchema={validationSchema}
    />
  );
};

export default AppFeatureControlForm;
